import { UPDATE_JS_MESSAGES, UPDATE_PAGE_MESSAGES } from 'apps/promo/actions/messageAction';
import update from 'apps/promo/helpers/Immutability';

const messages = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_PAGE_MESSAGES:
            return update(state, {
                pageMessages: { $merge: action.pageMessages },
            });
        case UPDATE_JS_MESSAGES:
            return update(state, {
                jsMessages: { $merge: action.jsMessages },
            });
        default:
            return state;
    }
};
export default messages;
